import React, { useState } from 'react';
import { Box, IconButton, makeStyles } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { shoppingExperienceColors } from '../../shoppingExperience/shared/constants';

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    width: '100%',
    height: 120,
    backgroundImage: props => `url(${props.image})`,
    backgroundPosition: 'center',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    marginBottom: '20px',
    cursor: 'pointer'
  },
  closeButton: {
    position: 'absolute',
    top: 15,
    right: 0,
    color: shoppingExperienceColors.white
  }
}));

const ChristmasInJuly2025 = ({ image, alt }) => {
  const classes = useStyles({ image });
  const [visible, setVisible] = useState(true);

  if (!visible) return null;

  const pageLink = 'catalog/collections/holiday-gifts?utm_source=Dashboard&utm_medium=Banner&utm_campaign=Holiday';

  const handleBannerClick = () => {
    window.open(pageLink, '_blank', 'noopener noreferrer');
  };

  const handleCloseClick = event => {
    event.stopPropagation();
    setVisible(false);
  };

  return (
    <Box
      id="dashboard-banner-XmasInJuly"
      data-gtm-id="dashboard-banner-XmasInJuly"
      data-cy="dashboard-banner-XmasInJuly"
      component="section"
      className={classes.root}
      aria-label={alt}
      onClick={handleBannerClick}
    >
      <IconButton className={classes.closeButton} size="small" onClick={handleCloseClick} aria-label="Close banner">
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
  );
};

ChristmasInJuly2025.defaultProps = {
  image: '/images/dashboard/xmas-In-July-banner-new.png',
  alt: 'Christmas in July Holiday Offer is here!'
};

export default ChristmasInJuly2025;
